module.exports = __webpack_public_path__ + "media/packs/images/partners/partner-logo7-174263e5576fb1c833dfbe012e7ee1ac.jpg";